"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/files/automaticFileConversion");
exports.initialState = {
    automaticFileConversion: {
        revisionUuid: '',
        preview: {
            conversionService: '',
            created_at: 0,
            key: '',
            status: 'NONE',
            uuid: ''
        },
        error: undefined
    }
};
const revisionUuidLens = monocle.Lens.fromPath(['automaticFileConversion', 'revisionUuid']);
const previewLens = monocle.Lens.fromPath(['automaticFileConversion', 'preview']);
const errorLens = monocle.Lens.fromPath(['automaticFileConversion', 'error']);
exports.methods = {};
exports.methods[ActionTypes.REVISION_CONVERSION_STATUS] = (state, action) => {
    return fp.function.flow(previewLens.set(action.payload.preview), revisionUuidLens.set(action.payload.revisionUuid), errorLens.set(undefined))(state);
};
exports.methods[ActionTypes.REVISION_CONVERSION_ERROR] = (state, action) => {
    return fp.function.flow(errorLens.set(action.payload.error), revisionUuidLens.set(action.payload.revisionUuid))(state);
};
//# sourceMappingURL=automaticFileConversion.js.map